import React from 'react';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

function CustomLink({ children, to, ...props }) {
    const resolved = useResolvedPath(to);
    const match = useMatch({ path: resolved.pathname, end: true });

    const commonStyle = 'h-16 flex items-center justify-center px-4'

    return (
        <div className={match ? `border-b-4 border-[#61ce70] ${commonStyle}` : `${commonStyle}`}>
            <Link style={{ color: match ? "" : "" }} to={to} {...props} >
                {children}
            </Link>
        </div>
    );
}

export default CustomLink;